// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.primary {
  margin-left: 5px;
}

.secondary {
  margin-left: 5px;
}

.table {
  height: 300px;
  overflow: hidden;
  margin-top: 5px;
  margin-bottom: 5px !important;
}

.left-margin {
  margin-left: 0px;
}

.map-row {
  min-height: 40vh;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
